/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_LaterInputs */

const en_dialog_later = /** @type {(inputs: Dialog_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const es_dialog_later = /** @type {(inputs: Dialog_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más tarde`)
};

/**
* | output |
* | --- |
* | "Later" |
*
* @param {Dialog_LaterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_later = /** @type {((inputs?: Dialog_LaterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_LaterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_later(inputs)
	return en_dialog_later(inputs)
});